export default __webpack_public_path__ + "static/media/icon_ambassador.a7590d97.svg";